/* Omino theme — light progressive-enhancement interactions.
   No dependencies. Everything degrades gracefully without JS. */
(function () {
  'use strict';

  /* ---- Mobile nav toggle ---- */
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-site-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---- Scroll reveal ---- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    revealEls.forEach(function (el) { el.classList.add('reveal'); io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---- Sticky bars: show once their sentinel scrolls above the viewport.
     Works for the homepage sticky-cart and the PDP sticky-pill alike. ---- */
  function wireStickyBar(barSelector, sentinelSelector) {
    var bar = document.querySelector(barSelector);
    var sentinel = document.querySelector(sentinelSelector);
    if (!bar || !sentinel || !('IntersectionObserver' in window)) return;
    var stickyIo = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    stickyIo.observe(sentinel);
  }
  wireStickyBar('[data-sticky-cart]', '[data-sticky-sentinel]');
  wireStickyBar('[data-sticky-pill]', '[data-sticky-pill-sentinel]');

  /* ---- Accordions (PDP buy box + FAQ) ---- */
  document.querySelectorAll('.pdp-accordion-header').forEach(function (header) {
    header.addEventListener('click', function () {
      var item = header.closest('.pdp-accordion-item');
      if (!item) return;
      var open = item.classList.toggle('is-open');
      header.setAttribute('aria-expanded', open ? 'true' : 'false');
      var icon = header.querySelector('.icon');
      if (icon) icon.textContent = open ? '−' : '+';
    });
  });

  /* ---- Ingredients library filter ---- */
  var ingPills = document.querySelectorAll('[data-ing-filter]');
  var ingCards = document.querySelectorAll('[data-ing-packet]');
  if (ingPills.length && ingCards.length) {
    ingPills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        ingPills.forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        var val = pill.dataset.ingFilter;
        ingCards.forEach(function (card) {
          card.style.display = (val === 'all' || card.dataset.ingPacket === val) ? '' : 'none';
        });
      });
    });
  }

  /* ---- Ingredient detail dialog ---- */
  var ingModal = document.querySelector('[data-ing-modal]');
  if (ingModal) {
    var mPanel   = ingModal.querySelector('.ing-modal-panel');
    var mImg     = ingModal.querySelector('[data-ing-modal-img]');
    var mPacket  = ingModal.querySelector('[data-ing-modal-packet]');
    var mTitle   = ingModal.querySelector('[data-ing-modal-title]');
    var mMeta    = ingModal.querySelector('[data-ing-modal-meta]');
    var mTags    = ingModal.querySelector('[data-ing-modal-tags]');
    var mBenefit = ingModal.querySelector('[data-ing-modal-benefit]');
    var mDetail  = ingModal.querySelector('[data-ing-modal-detail]');
    var mWorks   = ingModal.querySelector('[data-ing-modal-works]');
    var mWorksTx = ingModal.querySelector('[data-ing-modal-works-text]');
    var lastFocus = null;

    function setText(el, text) {
      if (!el) return;
      el.textContent = text || '';
      el.hidden = !text;
    }

    function openIng(btn) {
      var d = btn.dataset;
      setText(mPacket, d.ingPacketLabel ? d.ingPacketLabel + ' PACKET' : '');
      setText(mTitle, d.ingName);

      /* Dose, daily value and form read as one line rather than three stacked
         fragments, so the parts that are absent leave no gaps. */
      var meta = [];
      if (d.ingDose) meta.push(d.ingDose);
      if (d.ingDv) meta.push(d.ingDv + ' DV');
      if (d.ingForm) meta.push(d.ingForm);
      setText(mMeta, meta.join('  ·  '));

      setText(mBenefit, d.ingBenefit);

      /* Paragraph breaks in the detail copy are authored as blank lines. Build
         the paragraphs as nodes rather than assigning innerHTML, so merchant
         copy can never inject markup. */
      mDetail.textContent = '';
      var paras = (d.ingDetail || '').split(/\n\s*\n/);
      paras.forEach(function (t) {
        var s = t.replace(/\s+/g, ' ').trim();
        if (!s) return;
        var p = document.createElement('p');
        p.textContent = s;
        mDetail.appendChild(p);
      });
      mDetail.hidden = !mDetail.childNodes.length;

      if (mWorks) {
        if (mWorksTx) mWorksTx.textContent = d.ingWorks || '';
        mWorks.hidden = !d.ingWorks;
      }

      mTags.textContent = '';
      (d.ingTags || '').split(',').forEach(function (t) {
        var s = t.trim();
        if (!s) return;
        var li = document.createElement('li');
        li.textContent = s;
        mTags.appendChild(li);
      });
      mTags.hidden = !mTags.childNodes.length;

      if (d.ingImg) {
        mImg.src = d.ingImg;
        mImg.alt = d.ingName || '';
        mImg.hidden = false;
      } else {
        mImg.removeAttribute('src');
        mImg.hidden = true;
      }

      lastFocus = btn;
      ingModal.hidden = false;
      document.body.classList.add('is-modal-open');
      if (mPanel) { mPanel.scrollTop = 0; }
      var closeBtn = ingModal.querySelector('.ing-modal-close');
      if (closeBtn) closeBtn.focus();
    }

    function closeIng() {
      ingModal.hidden = true;
      document.body.classList.remove('is-modal-open');
      if (lastFocus) { lastFocus.focus(); lastFocus = null; }
    }

    document.querySelectorAll('[data-ing-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { openIng(btn); });
    });
    ingModal.querySelectorAll('[data-ing-close]').forEach(function (el) {
      el.addEventListener('click', closeIng);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !ingModal.hidden) closeIng();
      /* Keep Tab inside the dialog while it is open. */
      if (e.key === 'Tab' && !ingModal.hidden) {
        var f = ingModal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  /* ---- Subscription tier selector ---- */
  document.querySelectorAll('[data-tier-group]').forEach(function (group) {
    var tiers = group.querySelectorAll('.sub-tier');
    var ctaBtn = document.querySelector(group.dataset.tierGroup);
    tiers.forEach(function (tier) {
      tier.addEventListener('click', function () {
        tiers.forEach(function (t) { t.classList.remove('active'); });
        tier.classList.add('active');
        var radio = tier.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
        if (ctaBtn && tier.dataset.ctaLabel) ctaBtn.textContent = tier.dataset.ctaLabel;
        var variantInput = document.querySelector('[data-selected-variant]');
        if (variantInput && tier.dataset.variantId) variantInput.value = tier.dataset.variantId;
        var sellingPlanInput = document.querySelector('[data-selected-selling-plan]');
        if (sellingPlanInput) sellingPlanInput.value = tier.dataset.sellingPlanId || '';
      });
    });
  });

  /* ---- PDP gallery lightbox: full-screen viewer with slideshow ----
     Progressive enhancement — without this the tiles are inert buttons and the
     page still reads fine. Wired by delegation so it survives section re-render
     in the theme editor. */
  (function () {
    var box = document.querySelector('[data-lightbox]');
    if (!box) return;
    var slides = box.querySelectorAll('[data-lightbox-slide]');
    var thumbs = box.querySelectorAll('[data-lightbox-thumb]');
    var count = box.querySelector('[data-lightbox-count]');
    var total = slides.length;
    var index = 0;
    var lastFocus = null;

    function show(i) {
      index = (i + total) % total;
      for (var s = 0; s < total; s++) slides[s].hidden = (s !== index);
      for (var t = 0; t < thumbs.length; t++) {
        var on = (t === index);
        thumbs[t].classList.toggle('is-active', on);
        thumbs[t].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      if (count) count.textContent = (index + 1) + ' / ' + total;
    }
    function open(i) {
      lastFocus = document.activeElement;
      show(i);
      box.hidden = false;
      document.body.style.overflow = 'hidden';
      var close = box.querySelector('[data-lightbox-close]');
      if (close) close.focus();
    }
    function close() {
      box.hidden = true;
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-lightbox-open]');
      if (opener) { e.preventDefault(); open(parseInt(opener.getAttribute('data-lightbox-open'), 10) || 0); return; }
      if (box.hidden) return;
      if (e.target.closest('[data-lightbox-close]')) { close(); return; }
      if (e.target.closest('[data-lightbox-prev]')) { show(index - 1); return; }
      if (e.target.closest('[data-lightbox-next]')) { show(index + 1); return; }
      var thumb = e.target.closest('[data-lightbox-thumb]');
      if (thumb) show(parseInt(thumb.getAttribute('data-lightbox-thumb'), 10) || 0);
    });

    document.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(index - 1);
      else if (e.key === 'ArrowRight') show(index + 1);
    });

    /* Swipe between slides on touch. */
    var startX = null;
    var stage = box.querySelector('[data-lightbox-stage]');
    if (stage) {
      stage.addEventListener('touchstart', function (e) { startX = e.changedTouches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 45) show(dx < 0 ? index + 1 : index - 1);
        startX = null;
      }, { passive: true });
    }
  })();

  /* ---- Cart drawer ----
     Adds to cart over the AJAX API, then asks Shopify to re-render the drawer
     section and swaps the markup in. Totals and discounts therefore always come
     from Shopify, never from arithmetic here. Any failure falls back to a normal
     form post to the cart page, so buying never depends on this script. */
  (function () {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || !window.fetch) return;

    function openDrawer() {
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
      var close = drawer.querySelector('[data-cart-close]');
      if (close) close.focus();
    }
    function closeDrawer() {
      drawer.hidden = true;
      document.body.style.overflow = '';
    }

    function refresh(then) {
      var id = drawer.closest('.shopify-section');
      var name = id ? id.id.replace('shopify-section-', '') : 'cart-drawer';
      return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(name), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer]');
          if (!fresh) return;
          var wasOpen = !drawer.hidden;
          fresh.hidden = !wasOpen;
          drawer.replaceWith(fresh);
          drawer = fresh;
          if (typeof then === 'function') then();
        });
    }

    /* Open on any cart link, and on the drawer's own close controls. */
    document.addEventListener('click', function (e) {
      var cartLink = e.target.closest('a[href$="/cart"], a[href*="/cart?"], [data-cart-open]');
      if (cartLink) { e.preventDefault(); openDrawer(); return; }
      if (drawer.hidden) return;
      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }

      var qty = e.target.closest('[data-cart-qty]');
      if (qty) {
        e.preventDefault();
        qty.disabled = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: parseInt(qty.getAttribute('data-line'), 10), quantity: parseInt(qty.getAttribute('data-cart-qty'), 10) })
        }).then(function () { return refresh(); })
          .catch(function () { window.location.href = '/cart'; });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (!drawer.hidden && e.key === 'Escape') closeDrawer();
    });

    /* Intercept add-to-cart so the drawer opens instead of leaving the page. */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('form[action$="/cart/add"], form[action*="/cart/add"]')) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return refresh(openDrawer);
        })
        .catch(function () { form.submit(); })
        .then(function () { if (btn) btn.disabled = false; });
    });
  })();

})();
